import React, { useEffect, createElement } from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { ServiceGrid } from '../components/ServiceGrid';
import { Extras } from '../components/Extras';
import { About } from '../components/About';
import { ServiceAreas } from '../components/ServiceAreas';
import { Reviews } from '../components/Reviews';
import { Gallery } from '../components/Gallery';
import { FAQ } from '../components/FAQ';
import { SeoContent } from '../components/SeoContent';
import { ContactForm } from '../components/ContactForm';
import { Contact } from '../components/Contact';
import { homeFaqs } from '../data/faqs';
import { businessEntity, websiteEntity, injectJsonLd, setHeadMeta, BUSINESS_ID, WEBSITE_ID, SITE_URL } from '../utils/seo';
export function HomePage() {
  // Handle initial hash in URL on page load and SEO meta tags
  useEffect(() => {
    setHeadMeta({
      title: "Mobile Detailing Ventura County | Mobile Car Detailing | Mike's Pro Detail",
      description: 'Mobile detailing in Ventura County. Mike’s Pro Detail brings 5-star car detailing to your door in Camarillo, Oxnard, Ventura, Thousand Oaks & more. Call (818) 381-9905.',
      path: '/'
    });
    // Structured data: one linked @graph describing the business, the website,
    // the homepage itself, and the FAQ content that is visible on this page.
    const cleanup = injectJsonLd([businessEntity, websiteEntity, {
      '@type': 'WebPage',
      '@id': `${SITE_URL}/#webpage`,
      url: `${SITE_URL}/`,
      name: "Mobile Detailing Ventura County | Mike's Pro Detail",
      isPartOf: {
        '@id': WEBSITE_ID
      },
      about: {
        '@id': BUSINESS_ID
      },
      primaryImageOfPage: {
        '@id': BUSINESS_ID
      }
    }, {
      '@type': 'FAQPage',
      '@id': `${SITE_URL}/#faq`,
      isPartOf: {
        '@id': WEBSITE_ID
      },
      // Mirrors the visible FAQ accordion exactly (same source array).
      mainEntity: homeFaqs.map(f => ({
        '@type': 'Question',
        name: f.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: f.answer
        }
      }))
    }]);
    const hash = window.location.hash.slice(1);
    if (hash) {
      setTimeout(() => {
        const element = document.getElementById(hash);
        if (element) {
          const navHeight = 64;
          const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - navHeight;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
    return cleanup;
  }, []);
  return <main className="min-h-screen w-full bg-black text-white selection:bg-red-600 selection:text-white scroll-smooth" data-id="element-989" data-mp="2dnbx57hx3rlt">
      <Navigation data-id="element-990" data-mp="1l0zgpte08aqt" />
      <Hero data-id="element-991" data-mp="1l1izfcbhb35w" />
      <Services data-id="element-992" data-mp="1kzofo1by1h3e" />
      <Extras data-id="element-993" data-mp="1l07v9be4fte9" />
      <ServiceGrid data-id="element-994" data-mp="1kyn29q7ggiii" />
      <About data-id="element-995" data-mp="iozw7fzewsa" />
      <ServiceAreas data-id="element-996" data-mp="i6t4gvp1064" />
      <SeoContent data-id="element-997" data-mp="hnm3v7kzw6v" />
      <Reviews data-id="element-998" data-mp="h44ygpr9btw" />
      <Gallery data-id="element-999" data-mp="glxenxn7b6o" />
      <FAQ data-id="element-1000" data-mp="59f2xe0xqnjt" />
      <ContactForm data-id="element-1001" data-mp="595cxqfw4ge4" />
      <Contact data-id="element-1002" data-mp="59os4ze5oqog" />
    </main>;
}